import { EQuizMode } from '@constants';
import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const QuizService = sdk.getService('QuizService');

export const useCourseQuizzesByMode = (courseId?: string, mode?: EQuizMode) => {
  const { data, isLoading } = useQuery({
    queryKey: ['courseQuizzesByMode', courseId, mode],
    queryFn: () => QuizService.getCourseQuizzesByMode(courseId!, mode!),
    enabled: !!courseId && !!mode
  });

  return { quizzes: data, isLoading };
};
